<template>
  <tr>
    <td>
    <router-link :to="`/sales-return/${item.id}/view`" :key="item.code" title="View Sale">
        {{ item.code }}
      </router-link>
    </td>
  	<td>
      <router-link :to="`/proforma-invoice/${item.invoice_code}/view`" :key="item.invoice_code" title="View Sale">
        {{ item.invoice_code }}
      </router-link>
    </td>
    <td>{{ formatMysqlDate(item.added_time, 'Do MMM, YYYY') }}</td>
    <td>{{ item.type == config.invoiceTypes.customer ? item.customer_name : item.franchisee_name }}</td>
    <td>{{ item.retailer_name }}</td>
    <td class="text-xs-right">{{ item.grandtotal | roundValue }}</td>
    <td class="text-xs-center">{{ status }}</td>
    <td class="align-center justify-center layout px-0" v-if="!viewMode">
      <v-icon small class="mr-1" color="green" v-if="isPending" title="Confirm Sale Return" @click="$emit('confirm', item)">done</v-icon>
      <router-link :to="`/sales-return/${item.id}/approve`" title="Approve Sale Return" v-if="isConfirmed && hasAdminPrivilage">
        <v-icon small color="green" class="mr-1">done_all</v-icon>
      </router-link>
      <v-icon small class="mr-1" color="red" v-if="isPending || (isConfirmed && hasAdminPrivilage)" @click="$emit('cancel', item)" title="Cancel Sale Return">clear</v-icon>
      <router-link :to="`/sales-return/${item.id}`" v-if="hasEditAccess && isPending" title="Edit Sale Return">
        <v-icon small class="mr-1">edit</v-icon>
      </router-link>
      <!-- <a :href="`#/sales-return/${item.code}/print`" v-if="!isCancelled" target="_new" title="Print Sale Return" class="hidden-sm-and-down">
        <v-icon small class="mr-1">print</v-icon>
      </a> -->
    </td>
  </tr>
</template>
<script>
export default {
  name: 'SalesReturnListItem' ,
  props: {
    item: {
      required: true
    },
    viewMode: false
  },
  data () {
    return {
      
    }
  },
  
  methods: {

  },

  mounted () {
  	
  },

  computed: {
    
    isPending () {
      return this.item.status == this.config.saleReturnStatus.pending
    },

    isConfirmed () {
      return this.item.status == this.config.saleReturnStatus.confirmed
    },

    isApproved () {
      return this.item.status == this.config.saleReturnStatus.approved
    },

    isCancelled () {
      return this.item.status == this.config.saleReturnStatus.cancelled
    },

    status () {
      let status = ""
      switch(this.item.status) {
        case this.config.saleReturnStatus.pending:
          status = "Pending"
        break
        case this.config.saleReturnStatus.confirmed:
          status = "Confirmed"
        break
        case this.config.saleReturnStatus.approved:
          status = "Approved"
        break
        case this.config.saleReturnStatus.cancelled:
          status = "Cancelled"
        break
      }
      return status
    }

  },

  watch: {
    
  }
}
</script>